import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { LoginComponent } from "./login/login.component";
import { AppRoutingModule } from "./app.routing.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { MaterialModule } from "./material.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { LayoutComponent } from "./layout/layout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { GasProjectDialogComponent } from "./gas-project-dialog/gas-project-dialog.component";
import { FundingProjectComponent } from "./funding-project/funding-project.component";
import { ProjectLayoutComponent } from "./project-layout/project-layout.component";
import { ChargingProjectSetupComponent } from "./charging-project-setup/charging-project-setup.component";
import { ActivitySelectionComponent } from "./activity-selection/activity-selection.component";
import { ActivityDialogComponent } from "./activity-dialog/activity-dialog.component";
import { SummaryComponent } from "./summary/summary.component";
import { ProjectSetupsComponent } from "./project-setups/project-setups.component";
import { MatchingProjectDialogComponent } from "./matching-project-dialog/matching-project-dialog.component";
import { MsalBroadcastService, MsalInterceptor, MsalService } from "@azure/msal-angular";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MsalConfigDynamicModule } from "./msal-config-dynamic.model";

import { HttpModule } from "@angular/http";
import { ErrorDialogComponent } from "./error-dialog/error-dialog.component";
import { EstimateComponent } from "./estimate/estimate.component";
import { SuccessDialogComponent } from "./success-dialog/success-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";
import { ItProjectSetupComponent } from "./it-project-setup/it-project-setup.component";
import { ItProjectEstimateComponent } from "./it-project-estimate/it-project-estimate.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoaderModule, LoaderService } from "./shared/loader";
import { LoaderInterceptor } from "./shared/interceptors";
import { CapabilityDescriptionComponent } from "./capability-description/capability-description.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ItProjectReviewComponent } from "./it-project-review/it-project-review.component";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { CurrencyUSDPipe } from "./shared/pipes/usd-currency.pipe";
import { ItProjectApprovalComponent } from "./it-project-approval/it-project-approval.component";
import { TimeoutDialogComponent } from "./timeout-dialog/timeout-dialog.component";
import { DirectivesModule } from "./shared/directives/directives.module";
import { AddCharginDetailsDialogComponent } from "./add-charging-details-dialog/add-charging-details-dialog.component";
import { CurrencyMaskDirective } from "./shared/directives/currency-mask.directive";
import { AssignmentDialogComponent } from "./assignment-dialog/assignment-dialog.component";
import { ApproverDialogComponent } from "./approver-dialog/approver-dialog.component";
import { FormApprovalDialogComponent } from "./form-approval-dialog/form-approval-dialog.component";
import { AssignmentDashboardDialogComponent } from "./assignment-dashboard-dialog/assignment-dashboard-dialog.component";
import { ConfirmDeleteFormDialogComponent } from "./confirm-delete-form-dialog/confirm-delete-form-dialog.component";
import { ConfirmStartOverDialogComponent } from "./confirm-start-over-dialog/confirm-start-over-dialog.component";
import { RealEstateProjectTitleComponent } from "./real-estate-project/real-estate-project-title/real-estate-project-title.component";
import { RealEstateProjectComponent } from "./real-estate-project/real-estate-project.component";
import { RealEstateProjectDetailInfoComponent } from "./real-estate-project/real-estate-project-detail-info/real-estate-project-detail-info.component";
import { RealEstateService } from "./services/real-estate.service";
import { RealEstateProjectJustificationComponent } from "./real-estate-project/real-estate-project-justification/real-estate-project-justification.component";
import { AdaptiveIdDialogComponent } from "./real-estate-project/real-estate-project-detail-info/adaptive-id-dialog/adaptive-id-dialog.component";
import { RealEstateProjectUopComponent } from "./real-estate-project/real-estate-project-uop/real-estate-project-uop.component";
import { RealEstateProjectEstimateComponent } from "./real-estate-project/real-estate-project-estimate/real-estate-project-estimate.component";
import { AttachmentsSectionComponent } from "./real-estate-project/common/app-attachments-section/app-attachments-section.component";
import { RealEstateProjectApproverComponent } from "./real-estate-project/real-estate-project-approver/real-estate-project-approver.component";
import { RealEstateFormErrorDialogComponent } from "./real-estate-project/common/real-estate-form-error-dialog/real-estate-form-error-dialog.component";
import { RealEstateAssignmentDialogComponent } from "./real-estate-project/real-estate-assignment-dialog/real-estate-assignment-dialog.component";
import { DeSnackbarComponent } from "./shared/components/de-snackbar/de-snackbar.component";
import { LandServicesProjectDetailInfoComponent } from "./real-estate-project/land-services-project-detail-info/land-services-project-detail-info.component";
import { LandServicesProjectEstimateDetailsComponent } from "./real-estate-project/land-services-project-estimate-details/land-services-project-estimate-details.component";
import { LandServicesAccountingCodeblockComponent } from "./real-estate-project/land-services-accounting-codeblock/land-services-accounting-codeblock.component";
import { ReopenFormDialogComponent } from "./real-estate-form-dashboard/dialog/reopen-form-dialog.component";
import { UpdateRealEstateFormDialogComponent } from "./real-estate-form-dashboard/dialog/update-real-estate-form-dialog.component";
import { RealEstateFormActivityComponent } from "./real-estate-project/real-estate-form-activity/real-estate-form-activity.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FooterComponent,
    LayoutComponent,
    HeaderComponent,
    DashboardComponent,
    GasProjectDialogComponent,
    FundingProjectComponent,
    ProjectLayoutComponent,
    ChargingProjectSetupComponent,
    ActivitySelectionComponent,
    ActivityDialogComponent,
    SummaryComponent,
    ProjectSetupsComponent,
    MatchingProjectDialogComponent,
    ErrorDialogComponent,
    EstimateComponent,
    SuccessDialogComponent,
    ItProjectSetupComponent,
    ItProjectEstimateComponent,
    CapabilityDescriptionComponent,
    ItProjectReviewComponent,
    CurrencyUSDPipe,
    TimeoutDialogComponent,
    AddCharginDetailsDialogComponent,
    ItProjectApprovalComponent,
    AssignmentDialogComponent,
    ReopenFormDialogComponent,
    ApproverDialogComponent,
    FormApprovalDialogComponent,
    AssignmentDashboardDialogComponent,
    ConfirmDeleteFormDialogComponent,
    ConfirmStartOverDialogComponent,
    RealEstateProjectComponent,
    RealEstateProjectTitleComponent,
    RealEstateProjectDetailInfoComponent,
    RealEstateProjectJustificationComponent,
    AdaptiveIdDialogComponent,
    RealEstateProjectUopComponent,
    RealEstateProjectEstimateComponent,
    AttachmentsSectionComponent,
    RealEstateProjectApproverComponent,
    RealEstateAssignmentDialogComponent,
    RealEstateFormErrorDialogComponent,
    DeSnackbarComponent,
    LandServicesProjectDetailInfoComponent,
    LandServicesProjectEstimateDetailsComponent,
    LandServicesAccountingCodeblockComponent,
    UpdateRealEstateFormDialogComponent,
    RealEstateFormActivityComponent
  ],
  entryComponents: [
    GasProjectDialogComponent,
    ActivityDialogComponent,
    MatchingProjectDialogComponent,
    ErrorDialogComponent,
    SuccessDialogComponent,
    CapabilityDescriptionComponent,
    TimeoutDialogComponent,
    AddCharginDetailsDialogComponent,
    AssignmentDialogComponent,
    ApproverDialogComponent,
    FormApprovalDialogComponent,
    AssignmentDashboardDialogComponent,
    ConfirmDeleteFormDialogComponent,
    ConfirmStartOverDialogComponent,
    AdaptiveIdDialogComponent,
    RealEstateFormErrorDialogComponent,
    RealEstateAssignmentDialogComponent,
    DeSnackbarComponent,
    ReopenFormDialogComponent,
    UpdateRealEstateFormDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    MsalConfigDynamicModule.forRoot(),
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LoaderModule,
    ScrollingModule,
    DirectivesModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    MsalService,
    MsalBroadcastService,
    LoaderService,
    DecimalPipe,
    CurrencyPipe,
    CurrencyUSDPipe,
    RealEstateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
